import React from 'react';

import { withAuthorization } from '../session';
import ClassificationGroup from './ClassificationGroup';
import ClassificationElimination from './ClassificationElimination';

const ClassificationWorldCup = (props) => {

    const { tournament } = props;

    if (tournament.matchesGroupGenerated) {

        return (
            <div className="col-12 bg-white border border-white text-decoration-none rounded-lg p-0 mb-2 ">
                <nav className="small">
                    <div className=" rounded-lg nav nav-tabs  justify-content-center flex-row font-weight-bold" id="nav-tab" role="tablist">

                        <a className=" nav-item nav-link tab-material text-center text-dark active" id="nav-group-clas-tab" data-toggle="tab" href="#nav-group-clas" role="tab" aria-controls="nav-group-clas" aria-selected="true">
                            <span>Fase de Grupos</span>
                        </a>

                        <a className=" nav-item nav-link tab-material text-center text-dark " id="nav-elimination-clas-tab" data-toggle="tab" href="#nav-elimination-clas" role="tab" aria-controls="nav-elimination-clas" aria-selected="false">
                            <span>Eliminatoria</span>
                        </a>

                    </div>
                </nav>

                <div className="tab-content pt-2" id="nav-tabContent">

                    <div className="tab-pane fade show active" id="nav-group-clas" role="tabpanel" aria-labelledby="nav-group-clas-tab">
                        <ClassificationGroup {...props} />
                    </div>

                    <div className="tab-pane fade " id="nav-elimination-clas" role="tabpanel" aria-labelledby="nav-elimination-clas-tab">
                        <ClassificationElimination {...props} />
                    </div>

                </div>

            </div>
        )
    }

    return (
        <div className="nav justify-content-center pt-2">
            <span className="small font-italic text-black-50">Debe añadir los equipos y generar los partidos de la fase de grupos</span>
        </div>
    )
}

const condition = authUser => {
    if (!!authUser) {
        return authUser.token.admin || authUser.token.premium;
    } else
        return false;
};
export default withAuthorization(condition)(ClassificationWorldCup);